<div class="modal-header">
    <h4 class="modal-title" id="modal-title">{{ title }}</h4>
    <button type="button" class="btn-close" aria-describedby="modal-title" (click)="modal.dismiss()">
    </button>
</div>
<div class="modal-body">
    <form>
        <div class="mb-3 row">
            <label for="name" class="col-sm-2 col-form-label" jhiTranslate="field-manager.name">Name</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="name" name="name" [(ngModel)]="name"
                       maxlength="60" autocomplete="off" required>
                <div class="invalid-message">
                    {{ validationMessage }}
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="close()" jhiTranslate="cancel">Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="confirm()" jhiTranslate="ok">Ok</button>
</div>
